export default "__VITE_ASSET__692796ee__"